import { axiosRequest } from "../../../../service";
import { REACT_APP_KSHEMA_POC2 } from "../../../../urls";

export const getBasicSearchResults = async (searchFields, setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().post(
      `${REACT_APP_KSHEMA_POC2}/search`,
      {
        searchType: String(searchFields?.search_type?.value),
        product: searchFields?.product_name?.label,
        searchValue: searchFields?.search_type_value,
      }
    );
    setLoading(false);
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};

export const getAdvanceSearchResults = async (searchFields) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_KSHEMA_POC2}/advance-search?product_name=${
        searchFields.product_name.label
      }&state=${searchFields.state}&district=${searchFields.district}&mandal=${
        searchFields.mandal
      }&village=${searchFields.village}${
        searchFields.pincode ? `&pincode=${searchFields.pincode}` : ""
      }${
        searchFields.policyHolderName
          ? `&policyHolderName=${searchFields.policyHolderName}`
          : ""
      }`
    );
    return response;
  } catch (error) {
    console.error("Error while getting advance search results:", error);
    throw error;
  }
};
